import { useEffect, useRef, useState } from "react";

import { Button } from "./components/common/Button";
import { Card } from "./components/common/Card";
import { EmptyState } from "./components/common/EmptyState";
import TablePaginationBar from "../CommonComponents/TablePaginationBar";

import { TextInput } from "./components/common/FormInput";

import { TableRowSkeleton } from "./components/common/Skeleton";
import { Table, TBody, Td, Th, THead, Tr } from "./components/common/Table";

import { PriorityBadge } from "./components/inquiry/PriorityBadge";
import { FollowUpPanel } from "./components/inquiry/FollowUpPanel";
import AddEditInquiryModal from "./Inquirymodal";

import {
  useHistory,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";

import {
  addInquiry,
  editInquiry,
  getInquiryList,
} from "../../services/InqairyService";

import { connect } from "react-redux";
import { toastAlert } from "../../helpers/toastAlert";
import { getEmployees } from "../../services/employeeService";

import { formatDate, hasPermission } from "../../utils/commonutils";
import { INQUIRY_TYPE_OPTIONS } from "../../utils/fieldsConfig";
import { FALLBACK_INQUIRY_STATUS } from "../../utils/masterFallbacks";
import { useMasters, masterLabel } from "../../hooks/useMasters";
import {
  getInquiryWorkstreamPills,
} from "../../utils/inquiryWorkstream";

const labelize = (value) => {
  if (!value) return "—";
  return String(value)
    .replaceAll("_", " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const InquiryList = (props) => {
  const [busy, setBusy] = useState(false);
  const [followUpBefore, setFollowUpBefore] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [inquiries, setInquiries] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [q, setQ] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");
  const [presetType, setPresetType] = useState("");
  const openedFromQuery = useRef(false);
  const typeOptions = useMasters("inquiry_type", INQUIRY_TYPE_OPTIONS);
  const statusOptions = useMasters("inquiry_status", FALLBACK_INQUIRY_STATUS);
  const workstreamPills = getInquiryWorkstreamPills(props?.authData?.role);

  const navigate = useHistory();

  // 👇 Employee list
  const getEmployeeList = async () => {
    const employees = await getEmployees(props, 1, 100000000);
    if (employees?.data?.employees) {
      setEmployeeData(employees.data.employees);
    }
  };

  // 👇 Inquiry list with loader
  const fetchInquiry = async () => {
    try {
      setBusy(true);

      const activePill = workstreamPills.find((pill) => pill.key === typeFilter) || workstreamPills[0];
      const typeParam = activePill?.types ? activePill.types.join(",") : undefined;
      const res = await getInquiryList(props, page, limit, q, followUpBefore, typeParam);

      setInquiries(res?.data?.items || []);
      setTotal(res?.data?.total || 0);
    } catch (err) {
      console.error(err);
      setTotal(0);
      toastAlert("Failed to fetch inquiries", "error");
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    getEmployeeList();
  }, []);

  useEffect(() => {
    fetchInquiry();
  }, [page, limit, q, followUpBefore, typeFilter]);
  useEffect(() => {
    setPage(1);
  }, [q, typeFilter]);
  useEffect(() => {
    if (openedFromQuery.current) return;
    openedFromQuery.current = true;
    const params = new URLSearchParams(props.location?.search || "");
    const type = params.get("type");
    const openNew = params.get("new") === "1";
    if (type && workstreamPills.some((pill) => pill.key === type)) {
      setTypeFilter(type);
    }
    const nextType =
      type === "gst" || type === "payment_recovery" ? type : "";
    if (openNew && hasPermission("create_inquiry")) {
      setPresetType(nextType);
      setEditData(null);
      setOpenModal(true);
      params.delete("new");
      const nextSearch = params.toString();
      props.history.replace({
        pathname: props.location?.pathname || "/inquiary",
        search: nextSearch ? `?${nextSearch}` : "",
      });
    } else if (nextType) {
      setPresetType(nextType);
    }
  }, []);

  const openNewInquiry = () => {
    const fromFilter =
      typeFilter === "gst" || typeFilter === "payment_recovery" ? typeFilter : "";
    setPresetType(fromFilter);
    setEditData(null);
    setOpenModal(true);
  };

  const handleSave = async (data) => {
    try {
      let response;

      if (!editData) {
        response = await addInquiry(props, data);
        console.log("sdgdgdgg", response)
        if (response?.status) {
          toastAlert(
            response?.message || "Inquiry added successfully",
            "success",
          );
        } else {
          toastAlert(response?.message || "Failed", "error");
        }
      } else {
        response = await editInquiry(props, data, editData._id);
        console.log("fsdfksdfksd" ,response)
        if (response?.status) {
          toastAlert(
            response?.message || "Inquiry updated successfully",
            "success",
          );
        } else {
          toastAlert(response?.message || "Failed", "error");
        }
      }

      setOpenModal(false);
      fetchInquiry();
    } catch (err) {
      toastAlert("Something went wrong", "error");
    }
  };

  return (
    <div>
      <Card>
        <div className="mb-2 flex flex-wrap items-center gap-2">
          <div className="search-shell !mb-0 min-w-[220px] flex-1">
            <span className="text-slate-400">⌕</span>
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search name, phone, service"
            />
          </div>
          {hasPermission("create_inquiry") && (
            <Button
              size="sm"
              onClick={openNewInquiry}
            >
              New inquiry
            </Button>
          )}
        </div>
        <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
          <div className="filter-pills">
            {workstreamPills.map((pill) => (
              <button
                type="button"
                key={pill.key}
                className={`filter-pill ${typeFilter === pill.key ? "active" : ""}`}
                onClick={() => setTypeFilter(pill.key)}
              >
                {pill.label}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <TextInput
              type="date"
              className="!h-7 !w-[148px] !py-0.5 !px-2"
              value={followUpBefore}
              onChange={(e) => setFollowUpBefore(e.target.value)}
            />
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                setFollowUpBefore("");
                setQ("");
                setTypeFilter("all");
              }}
            >
              Reset
            </Button>
          </div>
        </div>

        {/* Empty State */}
        {!busy && inquiries.length === 0 && (
          <EmptyState
            title="No inquiries"
            description="Create your first inquiry"
          />
        )}

        {/* Table */}
        {(busy || inquiries.length > 0) && (
          <Table>
            <THead>
              <Th>Name</Th>
              <Th>Mobile</Th>
              <Th>Type</Th>
              <Th>Status</Th>
              <Th>Service</Th>
              <Th>Priority</Th>
              <Th>Source</Th>
              <Th>Assigned to</Th>
              <Th>Next follow-up</Th>
              <Th className="text-right">Actions</Th>
            </THead>

            <TBody>
              {busy
                ? Array.from({ length: limit }).map((_, i) => (
                    <TableRowSkeleton key={i} cols={10} />
                  ))
                : inquiries.map((row) => (
                    <Tr key={row._id}>
                      <Td>
                        <button
                          type="button"
                          className="font-semibold text-slate-900 hover:text-[#1a3366]"
                          onClick={() => navigate.push(`/inquiriedetail/${row._id}`)}
                        >
                          {row.name}
                        </button>
                      </Td>

                      <Td className="font-medium text-slate-900">
                        {row.mobile}
                      </Td>
                      <Td>
                        {masterLabel(typeOptions, row.type) || "General"}
                      </Td>
                      <Td>
                        {row.convertedTo
                          ? row.convertedTo === "payment_recovery"
                            ? "Recovery file"
                            : row.convertedTo === "gst"
                              ? "GST case"
                              : "Customer"
                          : masterLabel(statusOptions, row.status) || row.status || "New"}
                      </Td>

                      <Td>{row.service || "—"}</Td>

                      <Td>
                        {row?.priority ? (
                          <PriorityBadge priority={row.priority} />
                        ) : (
                          "—"
                        )}
                      </Td>

                      <Td>
                        {row?.source ? (
                          <span className="status-pill" style={{ background: "#e8eef8", color: "#1a3366" }}>
                            {labelize(row.source)}
                          </span>
                        ) : (
                          "—"
                        )}
                      </Td>

                      <Td>{row.assignedTo?.name || "—"}</Td>
                      <Td>
                        {formatDate(row?.nextFollowupDate) || (
                          <FollowUpPanel
                            inquiryId={row._id}
                            variant="modal"
                            showTimeline={false}
                            props={props}
                          />
                        )}
                      </Td>
                      <Td>
                        <div className="flex justify-end gap-3">
                          {hasPermission("view_inquiry") && (
                            <button
                              type="button"
                              className="text-[13px] font-semibold text-[#1a3366] hover:underline"
                              onClick={() =>
                                navigate.push(`/inquiriedetail/${row._id}`)
                              }
                            >
                              View
                            </button>
                          )}
                          {hasPermission("update_inquiry") &&
                            !row.convertedTo &&
                            row.status !== "converted" && (
                            <button
                              type="button"
                              className="text-[13px] font-semibold text-slate-500 hover:text-[#1a3366]"
                              onClick={() => {
                                setEditData(row);
                                setOpenModal(true);
                              }}
                            >
                              Edit
                            </button>
                          )}
                        </div>
                      </Td>
                    </Tr>
                  ))}
            </TBody>
          </Table>
        )}

        <TablePaginationBar
          page={page}
          rowsPerPage={limit}
          total={total}
          onPageChange={setPage}
          onRowsPerPageChange={(rows) => {
            setLimit(rows);
            setPage(1);
          }}
        />
      </Card>

      {/* Modal */}
      <AddEditInquiryModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        editData={editData}
        defaultType={presetType}
        onSubmit={handleSave}
        props={props}
        employeeData={employeeData}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(InquiryList));
